import { format, addMonths, addWeeks, addYears } from 'date-fns';



const calculateDueDates = (startDate, interval, term, amount, interest) => {
  const dueDates = [];
  const principalAmount = amount / term;
  const interestAmountInitial = (amount * interest) / 100;
  const interestAmountMinusAdvance = (((amount * interest) / 100) * term) - interestAmountInitial;
  const interestAmount = interestAmountMinusAdvance / term;
  
  let currentDate = new Date(startDate);

  for (let i = 0; i < term; i++) {
    switch (interval.toLowerCase()) {
      case 'monthly':
        currentDate = addMonths(currentDate, 1);
        break;
      case 'bimonthly': // Twice a month, roughly every two weeks
        currentDate = addWeeks(currentDate, 2);
        break;
      case 'weekly':
        currentDate = addWeeks(currentDate, 1);
        break;
      case 'quarterly':
        currentDate = addMonths(currentDate, 3);
        break;
      case 'semiannual':
        currentDate = addMonths(currentDate, 6);
        break;
      case 'yearly':
        currentDate = addYears(currentDate, 1);
        break;
      default:
        throw new Error('Invalid interval');
    }

    dueDates.push({
      date: format(currentDate, 'MM/dd/yyyy'),
      //dueAmount: roundUp(principalAmount + interestAmount)
      dueAmount: principalAmount + interestAmount
    });
  }

  return dueDates;
};


const calculatePayments = (date, interval, term, amount, interest, paymentList) => {
  const dueDates = calculateDueDates(date, interval, term, amount, interest);
  const initialIntrest = (amount * (interest/100));
  const totalRepayments = dueDates.reduce((acc, due) => acc + due.dueAmount, 0);

  let totalPaid = 0;
  let remainingBalance = totalRepayments;


  let total = 0;
  let paymentdate = null;

  if (paymentList && Array.isArray(paymentList) && paymentList.length > 0) {
    paymentList.forEach(payment => {
      total += payment.paidTotal;
    });
  
    totalPaid = (total + initialIntrest);
  
    paymentdate = paymentList[paymentList.length - 1].paymentDate;
  } else {
    totalPaid = initialIntrest; // only the advance interest
  }  

  remainingBalance = (totalRepayments - total);

  const paymentsArr = {
    'totalPaid': totalPaid.toFixed(2),
    'remainingBalance': remainingBalance.toFixed(2),
    'totalRepayments': totalRepayments.toFixed(2),
    'paymentDate': paymentdate
  };

  return paymentsArr;
};


export default calculatePayments;